import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import AcademyConfigProp from './propTypes/academyConfig';
import translate from '../../commonComponents/translate';
import { throttle } from '../../services/utilityFunctions';

function Hero({ academyConfig }) {
  const { heroImage, responsiveHeroImage, title, description } = academyConfig || {};
  const [useSmall, setUseSmall] = useState(false);

  const handleWindowResize = throttle(() => {
    if (window.matchMedia('(max-width: 768px)').matches) {
      setUseSmall(true);
    } else {
      setUseSmall(false);
    }
  }, 300);

  useEffect(() => {
    handleWindowResize();
    window.addEventListener('resize', handleWindowResize);

    return () => window.removeEventListener('resize', handleWindowResize);
  }, []);

  const image =
    useSmall && responsiveHeroImage ? responsiveHeroImage : heroImage;

  return (
    <div className="landing-hero" style={{ backgroundImage: `url(${image})` }}>
      <div className="landing-slider">
        <div className="col-lg-6 col-md-6 col-sm-12 ">
          <div className="landing-hero-text-box">
            <h1 className="landing-hero-title">{title}</h1>
            <h3 className="landing-hero-subtitle">{description}</h3>
          </div>
        </div>
      </div>
    </div>
  );
}

Hero.propTypes = {
  academyConfig: PropTypes.shape(AcademyConfigProp.propType).isRequired,
};

export default translate(Hero);
